import React from "react";


class Question extends React.PureComponent{

    constructor(props){
        super(props);

        this.state = {

            num:this.props.num,
            oHeight:0,
            height:'auto',
            show:true,

        }

        this.action = this.action.bind(this);
    }

    action(){

        if(window.innerWidth < 1000){

            this.setState({show:!this.state.show});

        }
        
    }

    componentDidMount(){

        var that = this;

        if(window.innerWidth < 1000){

            const height = that.divElement.clientHeight;
    
            that.setState({ height:height });

            that.setState({ oHeight:height });

            if(that.props.num !== 1){

                that.setState({ show:false});

            }

        }
    }

    render(){

        var styles = {
            "why-content":{
                desktop:{
                    position: 'relative',
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: '300',
                    fontSize: '18px',
                    lineHeight: '22px',
                    color: '#000000',
                    textAlign: 'left',
                    marginTop: '15px',
                    marginBottom: '15px',
                    padding: '6px 0px',

                },
                mobile:{
                    marginLeft: '14px',
                    textAlign: 'left',
                    fontSize: '16px',
                    lineHeight: '20px',
                    overflow: 'hidden',
                    transition: 'all .4s',
                    marginTop: '15px',
                    marginBottom: '15px',
                    padding: '6px 0px 0 24px',
                    height:this.state.height
                }
            }
        }

        return(
            <div className={((this.state.show ? "show" : "hide") )}>
                <p className="why-title" onClick={this.action}><span>{this.props.num}</span>{this.props.question}</p>

                <div className="why-content" style={(window.innerWidth > 1000 ? styles['why-content'].desktop : styles['why-content'].mobile)} ref={ (divElement) => { this.divElement = divElement } }>
                    {this.props.answer}
                </div>

            </div>
        )
    }

}

const Why = (props) => {

    const {content} = props;

    return (
        <div className="why-container">
  
            {
                content.map(function(benefit,i){
                  return <Question key={i} num={(i+1)} question={benefit.title} answer={benefit.answer}></Question>
                })
            }
  
        </div>
      );

}

export default Why;